import { render } from "./BulletinBoard.vue?vue&type=template&id=9e39ec48&scoped=true"
import script from "./BulletinBoard.vue?vue&type=script&lang=js"
export * from "./BulletinBoard.vue?vue&type=script&lang=js"

import "./BulletinBoard.vue?vue&type=style&index=0&id=9e39ec48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e39ec48"]])

export default __exports__